import React, { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import Spinner from "./utils/Spinner";

const Register = React.lazy(() => import("./pages/Register"));
const Login = React.lazy(() => import("./pages/Login"));
const ResetPassword = React.lazy(() => import("./pages/ResetPassword"));
const PrivacyPolicy = React.lazy(() => import("./pages/PrivacyPolicy"));
const TOC = React.lazy(() => import("./pages/TOC"));
const Invite = React.lazy(() => import("./pages/Invite"));

const PublicRoutes = () => {
	return (
		<Suspense fallback={<Spinner />}>
			<Routes>
				<Route path='/invite' element={<Invite />} />
				<Route path='/privacy-policy' element={<PrivacyPolicy />} />
				<Route path='/terms-of-use' element={<TOC />} />
				<Route path='/reset-password' element={<ResetPassword />} />
				<Route path='/login' element={<Login />} />
				<Route index element={<Register />} />
			</Routes>
		</Suspense>
	);
};

export const PUBLIC_ROUTES = [
	"/invite",
	"/privacy-policy",
	"/terms-of-use",
	"/reset-password",
	"/login",
	"/register",
	"/",
];

export default PublicRoutes;
